import React, { useState } from "react";
import MomentUtils from "@date-io/moment";
import moment, { Moment } from "moment";
import "moment/locale/pt-br";
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import EventIcon from "@material-ui/icons/Event";

const FORMATO_ISO = "YYYY-MM-DD";

const isoAte = (data: Moment | null, max: string) =>
  data && data.isValid() && data.format(FORMATO_ISO) <= max ? data.format(FORMATO_ISO) : "";

// O calendario fica dentro do painel em vez do popover do picker para o painel crescer junto com ele
export const CampoData = ({
  rotulo,
  valor,
  max,
  aoMudar,
  estilo,
}: {
  rotulo: string;
  valor: string;
  max: string;
  aoMudar: (iso: string) => void;
  estilo: React.CSSProperties;
}) => {
  const [rascunho, setRascunho] = useState<Moment | null>(null);
  const [calendarioAberto, setCalendarioAberto] = useState(false);
  const data = rascunho || (valor ? moment(valor, FORMATO_ISO) : null);

  const mudar = (nova: Moment | null) => {
    const iso = isoAte(nova, max);
    setRascunho(iso ? null : nova);
    aoMudar(iso);
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils} locale="pt-br">
      <KeyboardDatePicker
        value={data}
        onChange={(nova) => mudar(nova as Moment | null)}
        format="DD/MM/YYYY"
        placeholder="dd/mm/aaaa"
        maxDate={max}
        maxDateMessage="Data posterior a hoje"
        invalidDateMessage="Data inválida"
        open={false}
        onOpen={() => setCalendarioAberto(!calendarioAberto)}
        inputProps={{ "aria-label": rotulo }}
        KeyboardButtonProps={{ "aria-label": `Abrir calendário de ${rotulo}` }}
        InputAdornmentProps={{ style: { alignItems: "center" } }}
        keyboardIcon={<EventIcon style={{ top: 0 }} />}
        InputProps={{ disableUnderline: true, style: estilo }}
      />
      {calendarioAberto && (
        <div data-teste="calendario-inline">
          <DatePicker
            variant="static"
            disableToolbar
            autoOk
            value={data && data.isValid() ? data : null}
            maxDate={max}
            onChange={(nova) => {
              mudar(nova as Moment | null);
              setCalendarioAberto(false);
            }}
          />
        </div>
      )}
    </MuiPickersUtilsProvider>
  );
};
